import script from "./setPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./setPhone.vue?vue&type=script&setup=true&lang=js"

import "./setPhone.vue?vue&type=style&index=0&id=e7ed2222&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7ed2222"]])

export default __exports__